export const SORT_OPTIONS = [
  { id: "1", value: "leg_commited_dispatch_time", label: "Dispatch Time (Ascending)" },
  { id: "2", value: "-leg_commited_dispatch_time", label: "Dispatch Time (Descending)" },
  { id: "3", value: "po__total_po_raised_amount", label: "Total (Ascending)" },
  { id: "4", value: "-po__total_po_raised_amount", label: "Total (Descending)" },
  { id: "5", value: "created_at", label: "Created At (Ascending)" },
  { id: "6", value: "-created_at", label: "Created At (Descending)" },
  { id: "7", value: "lead_id", label: "Lead ID (Ascending)" },
  { id: "8", value: "-lead_id", label: "Lead ID (Descending)" },
];

export const STATUS_TYPES: Array<{ id: number; label: string; value: string; disabled?: boolean }> = [
  { id: 2, label: "Dispatch Pending", value: "dispatch_pending" },
  // { id: 99, label: "Delivery Assigned", value: "delivery_assigned" },
  // { id: 5, label: "In Warehouse", value: "in_store" },
  { id: 3, label: "Dispatched", value: "dispatched" },
  { id: 4, label: "Delivered", value: "delivered" },
  { id: 6, label: "Pickup Attempted", value: "pickup_attempted" },
  { id: 7, label: "Delivery Attempted", value: "delivery_attempted" },
  // { id: 19, label: "Return Requested", value: "return_requested" },
  // { id: 15, label: "Return Approved", value: "return_approved", disabled: true },
  // { id: 14, label: "Exchange Requested", value: "exchange_requested" },
  // { id: 16, label: "Exchange Approved", value: "exchange_approved", disabled: true },
  // { id: 17, label: "Refund Requested", value: "refund_requested" },
  // { id: 18, label: "Refund Approved", value: "refund_approved", disabled: true },
];
